import { SvgEtcReserv, SvgWeddingReserv } from "assets";
import { MMW_URL } from "assets/constant";
import {
  black,
  gray10,
  gray3,
  gray6,
  gray8,
  mainColor,
  redLightColor,
  white,
} from "assets/styleUtils";
import { Icon } from "components";
import useUser from "hooks/useUser";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getPoint } from "store/data/user";
import { fetcher } from "utils/ApiUtil";
import { numberText } from "utils/common";
import styles from "./style.module.css";

interface IPointData {
  point_sum: number;
  point: {
    createdAt: string;
    createdDt: string;
    point: number;
    point_no: number;
    status: number;
    title: string;
    user_no: number;
    type: string;
    pay_yn: string;
  }[];
  page: {
    cur: number;
    maxcnt: number;
    maxpage: number;
    path: string;
  };
}

interface IRankingData {
  desc: string;
  index: number;
  no: number;
  rank: "일반" | "드림";
  rank_img: string;
}

export default function MyPage() {
  const { user, logOut } = useUser();
  const navigate = useNavigate();
  const [pointData, setPointData] = useState<IPointData>();
  const [rankingData, setRankingData] = useState<IRankingData[]>();

  async function getInitData() {
    const { data } = await fetcher("/api/user/ranking");
    setRankingData(data.ranking);
    const point = (await getPoint("all")).data?.point || {};
    setPointData(point);
  }

  useEffect(() => {
    getInitData();
  }, []);

  return (
    <div style={{ flex: 1 }}>
      <div
        style={{
          width: "100%",
          minHeight: 227,
          backgroundColor: gray8,
          paddingBottom: 20,
        }}
      >
        <div style={{ padding: "60px 24px 0 24px" }}>
          <div style={{ display: "flex", flexDirection: "row" }}>
            <img
              style={{
                width: "40.37px",
                height: "40.37px",
                borderRadius: "50%",
              }}
              src={user?.profile_img ?? "/images/defaultImg.png"}
            />
            <div
              className={styles.flexAlign}
              style={{
                marginLeft: "10px",
                fontSize: "24px",
                fontWeight: "600",
              }}
            >
              {user?.nickname}
            </div>
            <div
              style={{
                marginLeft: "10px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                cursor: "pointer",
              }}
              onClick={() => navigate("/SignIn/MyProfilePage")}
            >
              <Icon name="arrowRight" color="#AEB1B6" size={50} />
            </div>
          </div>
          <div style={{ marginTop: "12px", color: gray3, lineHeight: "150%" }}>
            {`${user?.nickname}님의 등급은 `}
            <span
              style={{
                color: user?.rank === "일반" ? mainColor : redLightColor,
              }}
            >
              {user?.rank}
              {user?.auth_type ? ` / ${user?.auth_type}` : undefined}
            </span>
            {`입니다.`}
          </div>
          {user?.wait_auth_type ? (
            <span
              style={{
                marginTop: 4,
                color: redLightColor,
                lineHeight: "150%",
                fontSize: 12,
              }}
            >
              {user?.wait_auth_type} 인증 처리 대기중
            </span>
          ) : undefined}

          <div
            className={styles.flexAlign}
            style={{
              height: "60px",
              backgroundColor: white,
              marginTop: "14px",
              paddingLeft: "14px",
            }}
          >
            <div
              className={styles.flexAlign}
              style={{
                width: "25px",
                height: "25px",
                marginTop: "-3px",
                borderRadius: "50%",
                backgroundColor: black,
                justifyContent: "center",
              }}
            >
              <img
                src="/images/p@3x.png"
                style={{
                  width: "9px",
                  height: "12px",
                  backgroundColor: black,
                }}
              />
            </div>
            <div
              style={{
                fontSize: "24px",
                fontWeight: "700",
                marginLeft: "10px",
              }}
            >
              {numberText(String(pointData?.point_sum || 0))}P
            </div>
          </div>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          textAlign: "center",
          justifyContent: "space-between",
          padding: "20px",
          borderBottom: `1px solid ${gray6}`,
        }}
      >
        <div
          className={styles.horizontal}
          onClick={() => navigate("/SignIn/InquiryBoxList?type=wedding")}
        >
          <div>
            <SvgWeddingReserv />
            <div style={{ lineHeight: "110%", marginTop: "10px" }}>
              웨딩홀 <br />
              예약관리
            </div>
          </div>
        </div>
        <div
          className={styles.horizontal}
          onClick={() => navigate("/SignIn/InquiryBoxList?type=etc")}
        >
          <div>
            <SvgEtcReserv />
            <div style={{ lineHeight: "110%", marginTop: "10px" }}>
              기타 <br />
              예약관리
            </div>
          </div>
        </div>
      </div>
      <div style={{ padding: "0 24px" }}>
        <div
          onClick={() => navigate("/SignIn/MyPointList")}
          className={styles.contentItem}
        >
          계약포인트 신청
        </div>
      </div>
      <div
        style={{
          borderTop: `1px solid ${gray6}`,
          borderBottom: `1px solid ${gray6}`,
          padding: "30px",
          marginTop: "30px",
        }}
      >
        <div style={{ fontSize: "17px", fontWeight: "500" }}>고객센터</div>
        <div
          style={{
            fontSize: "12px",
            fontWeight: "500",
            color: gray10,
            marginTop: "8px",
            lineHeight: "150%",
          }}
        >
          챗봇 버튼을 눌러 고객센터로 빠르게 연결해보세요.
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: "8px",
          }}
        >
          <div
            className={styles.flexAlign}
            style={{
              fontSize: "12px",
              fontWeight: "500",
              color: gray10,
              height: "34px",

              lineHeight: "150%",
            }}
          >
            평일 9:00 ~ 18:00 <br />
            (12:00 ~ 13:00 점심시간)
          </div>
        </div>
      </div>
      <div
        className={styles.flexAlign}
        style={{
          marginTop: 50,
          marginBottom: 50,
          justifyContent: "center",
          fontWeight: "500",
          fontSize: "14px",
          lineHeight: "150%",
          color: gray10,
          cursor: "pointer",
        }}
        onClick={() => {
          logOut();
          navigate("/SignIn");
        }}
      >
        로그아웃
      </div>
    </div>
  );
}
